import { useMutation } from 'react-query';
import Amplify, { Auth } from 'aws-amplify';

import { useClient } from '../../components/hooks';
import { CognitoUser } from '../../types/user';
import { requireMFASetup, requireMFAValidation } from '../../utils/helper';

const [SrpType, PwdType] = [
  process.env.authSRPFlowType,
  process.env.authPWDFlowType,
];

const cognitoLogin = async ({
  username,
  password,
  authFlow = SrpType,
}: {
  username: string;
  password: string;
  authFlow?: string;
}): Promise<CognitoUser> => {
  try {
    if (authFlow === PwdType)
      Amplify.configure({
        Auth: {
          authenticationFlowType: PwdType,
        },
      });

    const resp = await Auth.signIn(username, password, {
      ...(authFlow === PwdType ? { um: 'True' } : { um: 'False' }),
    });

    if (authFlow === PwdType)
      Amplify.configure({
        Auth: {
          authenticationFlowType: SrpType,
        },
      });

    return resp;
  } catch (err) {
    if (err?.code === 'NotAuthorizedException' && authFlow === SrpType) {
      const resp: any = await cognitoLogin({
        username,
        password,
        authFlow: PwdType,
      });
      return resp;
    } else {
      throw err;
    }
  }
};

export function useMutateUserSignIn() {
  const { getMfaToken, clientId } = useClient();
  return useMutation(
    async ({
      emailOrUsername,
      password,
    }: {
      emailOrUsername: string;
      password: string;
    }): Promise<[CognitoUser, string]> => {
      const user = await cognitoLogin({
        username: emailOrUsername,
        password: password,
      });
      const mfaToken = getMfaToken();
      if (user?.challengeName) return [user, 'challenge'];
      else if (await requireMFAValidation(user, mfaToken, clientId))
        return [user, 'validateMfa'];
      else if (requireMFASetup(user)) return [user, 'setupMfa'];
      return [user, ''];
    }
  );
}
